const	columns = ({ t, locales }) => ([{
	caption: t('common.strings.branch'),
	dataField: 'shopName',
	width: 200,
	Footer: 'Total:'
}, {
	caption: t('common.fields.code'),
	dataField: 'code'
}, {
	caption: t('common.fields.name'),
	dataField: 'name',
	width: 200
}, {
	caption: `${t('statistic_section.strings.group')} 1`,
	dataField: 'group1'
}, {
	caption: `${t('statistic_section.strings.group')} 2`,
	dataField: 'group2'
}, {
	caption: `${t('statistic_section.strings.group')} 3`,
	dataField: 'group3'
}, {
	caption: t('statistic_section.strings.sales_group'),
	dataField: 'salesGroup',
	width: 200
}, {
	caption: t('common.fields.number'),
	dataField: 'number',
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' }
}, {
	caption: t('common.fields.number'),
	dataField: 'number_compare',
	compare: true,
	cssClass: 'cell-colored',
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' }
}, {
	caption: t('common.fields.amount'),
	dataField: 'total',
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' }
}, {
	caption: t('common.fields.amount'),
	dataField: 'total_compare',
	compare: true,
	cssClass: 'cell-colored',
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' }
}, {
	caption: t('statistic_section.strings.weight'),
	dataField: 'weight',
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float', precision: 3 }
}, {
	caption: t('statistic_section.strings.weight'),
	dataField: 'weight_compare',
	compare: true,
	cssClass: 'cell-colored',
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float', precision: 3 }
}, {
	caption: t('statistic_section.strings.total_cc'),
	dataField: 'creditCustomerTotal',
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' }
}, {
	caption: t('statistic_section.strings.total_cc'),
	dataField: 'creditCustomerTotal_compare',
	compare: true,
	cssClass: 'cell-colored',
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' }
}, {
	caption: t('common.strings.credit_customer'),
	dataField: 'creditCustomer',
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float', precision: 0 }
}, {
	caption: t('common.strings.credit_customer'),
	dataField: 'creditCustomer_compare',
	compare: true,
	cssClass: 'cell-colored',
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float', precision: 0 }
}, {
	caption: t('statistic_section.strings.weight_cc'),
	dataField: 'creditCustomerWeight',
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float', precision: 3 }
}, {
	caption: t('statistic_section.strings.weight_cc'),
	dataField: 'creditCustomerWeight_compare',
	compare: true,
	cssClass: 'cell-colored',
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float', precision: 3 }
}, {
	caption: t('statistic_section.strings.order'),
	dataField: 'order1',
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float', precision: 0 }
}, {
	caption: t('statistic_section.strings.order'),
	dataField: 'order1_compare',
	compare: true,
	cssClass: 'cell-colored',
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float', precision: 0 }
}, {
	caption: t('statistic_section.strings.return'),
	dataField: 'unsold',
	rotate: true,
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float', precision: 3 }
}, {
	caption: t('statistic_section.strings.return'),
	dataField: 'unsold_compare',
	rotate: true,
	compare: true,
	cssClass: 'cell-colored',
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float', precision: 0 }
}, {
	caption: `${t('statistic_section.strings.return')} ${t('common.fields.amount')}`,
	dataField: 'unsoldAmount',
	rotate: true,
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' }
}, {
	caption: `${t('statistic_section.strings.return')} ${t('common.fields.amount')}`,
	dataField: 'unsoldAmount_compare',
	rotate: true,
	compare: true,
	cssClass: 'cell-colored',
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' }
}, {
	caption: `${t('statistic_section.strings.return')} % (${t('common.strings.item')})`,
	dataField: 'unsoldPercent',
	rotate: true,
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' }
}, {
	caption: `${t('statistic_section.strings.return')} % (${t('common.strings.item')})`,
	dataField: 'unsoldPercent_compare',
	rotate: true,
	compare: true,
	cssClass: 'cell-colored',
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' }
}, {
	caption: t('statistic_section.strings.delivery'),
	dataField: 'deliver',
	rotate: true,
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' }
}, {
	caption: t('statistic_section.strings.delivery'),
	dataField: 'deliver_compare',
	rotate: true,
	compare: true,
	cssClass: 'cell-colored',
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' }
}, {
	caption: t('options_section.strings.delivery_correction'),
	dataField: 'correction',
	rotate: true,
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' }
}, {
	caption: t('options_section.strings.delivery_correction'),
	dataField: 'correction_compare',
	rotate: true,
	compare: true,
	cssClass: 'cell-colored',
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' }
}, {
	caption: t('options_section.strings.delivery_correction_amount'),
	dataField: 'correctionAmount',
	rotate: true,
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' }
}, {
	caption: t('options_section.strings.delivery_correction_amount'),
	dataField: 'correctionAmount_compare',
	rotate: true,
	compare: true,
	cssClass: 'cell-colored',
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' }
}, {
	caption: t('statistic_section.strings.old_stock'),
	dataField: 'oldStock',
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' }
}, {
	caption: t('statistic_section.strings.old_stock'),
	dataField: 'oldStock_compare',
	compare: true,
	cssClass: 'cell-colored',
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' }
}, {
	caption: t('statistic_section.strings.stock_number'),
	dataField: 'stock',
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' }
}, {
	caption: t('statistic_section.strings.stock_amount'),
	dataField: 'stockAmount',
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' }
}, {
	caption: t('statistic_section.strings.stock_number'),
	dataField: 'stock_compare',
	compare: true,
	cssClass: 'cell-colored',
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' }
}, {
	caption: t('statistic_section.strings.difference'),
	dataField: 'difference',
	rotate: true,
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float', precision: 0 }
}, {
	caption: t('statistic_section.strings.difference'),
	dataField: 'difference_compare',
	rotate: true,
	compare: true,
	cssClass: 'cell-colored',
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float', precision: 0 }
}, {
	caption: t('statistic_section.strings.difference_amount'),
	dataField: 'differenceAmount',
	rotate: true,
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' }
}, {
	caption: t('statistic_section.strings.difference_amount'),
	dataField: 'differenceAmount_compare',
	rotate: true,
	compare: true,
	cssClass: 'cell-colored',
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' }
}, {
	caption: t('statistic_section.strings.date_time'),
	dataField: 'dateTime',
	localFormat: { type: 'date' },
	width: 200
}, {
	caption: t('closing_section.fields.bill_count'),
	dataField: 'supportingDocuments',
	calculateCellValue: ({ billAmount1, billAmount2, billAmount3, billAmount4 }) => billAmount1 + billAmount2 + billAmount3 + billAmount4,
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float', precision: 0 }
}, {
	caption: t('closing_section.fields.bill_count'),
	dataField: 'supportingDocumentsCompare',
	compare: true,
	cssClass: 'cell-colored',
	calculateCellValue: ({ billAmount1_compare, billAmount2_compare, billAmount3_compare, billAmount4_compare }) => billAmount1_compare + billAmount2_compare + billAmount3_compare + billAmount4_compare,
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float', precision: 0 }
}, {
	caption: 'x1',
	dataField: 'billAmount1',
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float', precision: 0 }
}, {
	caption: 'x1',
	dataField: 'billAmount1_compare',
	compare: true,
	cssClass: 'cell-colored',
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float', precision: 0 }
}, {
	caption: 'x2',
	dataField: 'billAmount2',
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float', precision: 0 }
}, {
	caption: 'x2',
	dataField: 'billAmount2_compare',
	compare: true,
	cssClass: 'cell-colored',
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float', precision: 0 }
}, {
	caption: 'x3',
	dataField: 'billAmount3',
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float', precision: 0 }
}, {
	caption: 'x3',
	dataField: 'billAmount3_compare',
	compare: true,
	cssClass: 'cell-colored',
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float', precision: 0 }
}, {
	caption: '>x3',
	dataField: 'billAmount4',
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float', precision: 0 }
}, {
	caption: '>x3',
	dataField: 'billAmount4_compare',
	compare: true,
	cssClass: 'cell-colored',
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float', precision: 0 }
}, {
	caption: t('statistic_section.strings.unique'),
	dataField: 'onlyThis',
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float', precision: 0 }
}, {
	caption: t('statistic_section.strings.unique'),
	dataField: 'onlyThis_compare',
	compare: true,
	cssClass: 'cell-colored',
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float', precision: 0 }
}, {
	caption: t('statistic_section.strings.first_sale'),
	dataField: 'firstSale',
	localFormat: { type: 'time' },
	width: 100
}, {
	caption: t('statistic_section.strings.first_sale'),
	dataField: 'firstSale_compare',
	compare: true,
	cssClass: 'cell-colored',
	localFormat: { type: 'time' },
	width: 100
}, {
	caption: t('statistic_section.strings.last_sale'),
	dataField: 'lastSale',
	localFormat: { type: 'time' },
	width: 100
}, {
	caption: t('statistic_section.strings.last_sale'),
	dataField: 'lastSale_compare',
	compare: true,
	cssClass: 'cell-colored',
	localFormat: { type: 'time' },
	width: 100
}, {
	caption: t('statistic_section.strings.number_in_cafe'),
	dataField: 'inCafeNumber',
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float', precision: 0 }
}, {
	caption: t('statistic_section.strings.number_in_cafe'),
	dataField: 'inCafeNumber_compare',
	compare: true,
	cssClass: 'cell-colored',
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float', precision: 0 }
}, {
	caption: t('statistic_section.strings.in_cafe_sales'),
	dataField: 'inCafeTotal',
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' }
}, {
	caption: t('statistic_section.strings.in_cafe_sales'),
	dataField: 'inCafeTotal_compare',
	compare: true,
	cssClass: 'cell-colored',
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' }
}, {
	dataField: 'outsideNumber',
	caption: t('statistic_section.strings.outside_number'),
	calculateCellValue: ({ number, inCafeNumber }) => number - inCafeNumber,
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float', precision: 0 },
	width: 130
}, {
	dataField: 'outsideNumberCompare',
	caption: t('statistic_section.strings.outside_number'),
	compare: true,
	cssClass: 'cell-colored',
	calculateCellValue: ({ number_compare, inCafeNumber_compare }) => number_compare - inCafeNumber_compare,
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float', precision: 0 },
	width: 130
}, {
	caption: t('statistic_section.strings.outside_sales'),
	dataField: 'outsideSales',
	calculateCellValue: ({ total, inCafeTotal }) => total - inCafeTotal,
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' },
	width: 130
}, {
	caption: t('statistic_section.strings.outside_sales'),
	dataField: 'outsideSalesCompare',
	compare: true,
	cssClass: 'cell-colored',
	calculateCellValue: ({ total_compare, inCafeTotal_compare }) => total_compare - inCafeTotal_compare,
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' },
	width: 130
}, {
	caption: t('statistic_section.strings.promotion_number'),
	dataField: 'promotionNumber',
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float', precision: 0 }
}, {
	caption: t('statistic_section.strings.promotion_number'),
	dataField: 'promotionNumber_compare',
	compare: true,
	cssClass: 'cell-colored',
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float', precision: 0 }
}, {
	caption: t('statistic_section.strings.promotion_sales'),
	dataField: 'promotionTotal',
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' }
}, {
	caption: t('statistic_section.strings.promotion_sales'),
	dataField: 'promotionTotal_compare',
	compare: true,
	cssClass: 'cell-colored',
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' }
}, {
	caption: t('statistic_section.strings.selection_number'),
	dataField: 'breakfastNumber',
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float', precision: 0 },
	width: 120
}, {
	caption: t('statistic_section.strings.selection_number'),
	dataField: 'breakfastNumber_compare',
	compare: true,
	cssClass: 'cell-colored',
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float', precision: 0 },
	width: 120
}, {
	caption: t('statistic_section.strings.selection_sales'),
	dataField: 'breakfastTotal',
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' },
	width: 120
}, {
	caption: t('statistic_section.strings.selection_sales'),
	dataField: 'breakfastTotal_compare',
	compare: true,
	cssClass: 'cell-colored',
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' },
	width: 120
}, {
	caption: t('statistic_section.strings.discount_number'),
	dataField: 'discountNumber',
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float', precision: 0 }
}, {
	caption: t('statistic_section.strings.discount_number'),
	dataField: 'discountNumber_compare',
	compare: true,
	cssClass: 'cell-colored',
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float', precision: 0 }
}, {
	caption: t('statistic_section.strings.discount_sales'),
	dataField: 'discountTotal',
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' }
}, {
	caption: t('statistic_section.strings.discount_sales'),
	dataField: 'discountTotal_compare',
	compare: true,
	cssClass: 'cell-colored',
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' }
}, {
	caption: t('statistic_section.strings.gross_profit'),
	dataField: 'grossProfit',
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' }
}, {
	caption: t('statistic_section.strings.gross_profit'),
	dataField: 'grossProfit_compare',
	compare: true,
	cssClass: 'cell-colored',
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' }
}, {
	caption: t('statistic_section.strings.contribution_margin'),
	dataField: 'contributionMargin',
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' }
}, {
	caption: t('statistic_section.strings.contribution_margin'),
	dataField: 'contributionMargin_compare',
	compare: true,
	cssClass: 'cell-colored',
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' }
}, {
	caption: '%',
	dataField: 'g1Percent',
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' }
}, {
	caption: '%',
	dataField: 'g1Percent_compare',
	compare: true,
	cssClass: 'cell-colored',
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' }
}, {
	caption: '+%',
	dataField: 'g1PercentT',
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' }
}, {
	caption: '+%',
	dataField: 'g1PercentT_compare',
	compare: true,
	cssClass: 'cell-colored',
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	},
	localFormat: { type: 'float' }
}, {
	caption: 'ABC',
	dataField: 'g1Abc'
}, {
	caption: 'ABC',
	dataField: 'g1Abc_compare',
	compare: true,
	cssClass: 'cell-colored'
}, {
	caption: t('common.fields.number_short'),
	dataField: 'gNumber'
}, {
	caption: t('common.fields.number_short'),
	dataField: 'gNumber_compare',
	compare: true,
	cssClass: 'cell-colored'
}])

export default columns
